import React from "react";
import PropTypes from "prop-types";
import { useField } from "formik";

import "../../../styles/textarea.scss";

const TextArea = ({ label, placeholder, style, maxLength, ...props }) => {
  const [field, meta] = useField(props);

  const classNames = ["textarea"];

  if (meta.touched && meta.error) classNames.push("textarea--error");

  return (
    <div className={classNames.join(" ")} style={{ ...style }}>
      {label && <span className="textarea__label">{label}</span>}
      <div className="textarea-container">
        <textarea
          className="textarea-control"
          {...field}
          {...props}
          placeholder={placeholder}
          wrap="hard"
          maxLength={maxLength}
        >
          {field.value}
        </textarea>
        {maxLength && (
          <div className="textarea__max-length">{`${
            field.value ? field.value.toString().length : 0
          }/${maxLength}`}</div>
        )}
      </div>
      {meta.touched && meta.error && (
        <span className="textarea__error">{meta.error}</span>
      )}
    </div>
  );
};

TextArea.propTypes = {
  placeholder: PropTypes.string,
  style: PropTypes.object,
};

TextArea.defaultProps = {
  placeholder: "",
  style: {},
};

export default TextArea;
